<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="12"
            class="text-right"
          >
            <b-button
              variant="primary"
              :to="$route.path + '/add'"
            >
              <feather-icon icon="PlusIcon" />
              Oluştur
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <template v-if="dataList.length > 0">
        <b-table
          responsive="sm"
          :fields="fields"
          :items="dataList"
          striped
        >
          <template #cell(title)="data">
            {{ data.item.title }}
            <div v-if="data.item.url">
              <small class="text-primary">{{ data.item.url }}</small>
            </div>
          </template>
          <template #cell(status)="data">
            <b-badge
              v-if="data.item.status === '1'"
              size="sm"
              variant="light-primary"
            >
              Aktif
            </b-badge>
            <b-badge
              v-if="data.item.status === '0'"
              size="sm"
              variant="light-danger"
            >
              Pasif
            </b-badge>
          </template>
          <template #cell(control)="data">
            <div class="text-right">
              <list-buttons
                primary-text="Görüntüle"
                :primary-action="$route.path + '/edit/' + data.item.id"
                :edit-action="$route.path + '/edit/' + data.item.id"
                :delete-action="removeData"
                :data-id="data.item.id"
              />
            </div>
          </template>
        </b-table>
        <b-card-footer>
          <b-pagination
            v-model="currentPage"
            :total-rows="dataCounts"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-card-footer>
      </template>
      <b-alert
        v-else
        show
        variant="info"
        class="m-2"
      >
        <div class="alert-body text-center">
          <FeatherIcon icon="InfoIcon" />
          Kayıtlı veri bulunamadı.
        </div>
      </b-alert>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BCol, BRow, BCardBody, BCardFooter, BPagination, BTable, BButton, BAlert, BBadge,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListDropdownButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'projects'

export default {
  name: 'Index',
  components: {
    BAlert,
    BCard,
    BCol,
    BRow,
    BCardBody,
    BCardFooter,
    BPagination,
    ListButtons,
    BTable,
    BButton,
    BBadge,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'title',
          label: 'Ürün',
        },
        {
          key: 'status',
          label: '',
          thStyle: { width: '100px' },
        },
        {
          key: 'control',
          label: '',
          thStyle: { width: '180px' },
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          `${tableName}.url AS url`,
          `${tableName}.status AS status`,
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['projects/dataList']
    },
    dataCounts() {
      return this.$store.getters['projects/dataCounts']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getDataList()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.getDataList()
      }
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('projects/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('projects/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
